import React, {useMemo} from 'react';
import {Link} from 'react-router-dom';
import classNames from 'classnames';
import objectPath from 'object-path';
import Brand from '../Brand';
import {AsideMenu} from './AsideMenu';
import {useHtmlClassService} from '../../../../../_metronic/layout';
import styles from './styles.module.scss';
import themeStyles from '../../styles/theme.module.scss';
import {useGlobalContext} from "../../contexts/GlobalContext";

export function Aside() {
  const uiService = useHtmlClassService();
  const {isGlassTheme} = useGlobalContext();
  const layoutProps = useMemo(() => {
    return {
      disableScroll:
        objectPath.get(uiService.config, 'aside.menu.dropdown') === 'true' ||
        false,
      asideClassesFromConfig: uiService.getClasses('aside', true),
      disableAsideSelfDisplay:
        objectPath.get(uiService.config, 'aside.self.display') === false,
      headerLogo: uiService.getLogo()
    };
  }, [uiService]);

  return (
    <div
      id="kt_aside"
      className={classNames(
        styles.asideContainer,
        isGlassTheme ? themeStyles.filter : themeStyles.noFilter,
        isGlassTheme ? '' : themeStyles.usualHeaderBackground,
        `aside aside-left ${layoutProps.asideClassesFromConfig} d-flex flex-column flex-row-auto`,
      )}
    >
      <Brand/>
      <div
        id="kt_aside_menu_wrapper"
        className="aside-menu-wrapper flex-column-fluid"
      >
        {layoutProps.disableAsideSelfDisplay && (
          <div className="header-logo">
            <Link to="/">
              <img alt="logo" src={layoutProps.headerLogo}/>
            </Link>
          </div>
        )}
        <AsideMenu/>
      </div>
    </div>
  );
}
